import { Check } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Button, DialogContent, DialogTitle, Typography } from '@mui/material';
import { MutationOptions } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
  UpdateInvoiceAmountDueMutation,
  UpdateInvoiceAmountDueMutationVariables,
  useUpdateInvoiceAmountDueMutation,
} from '../../../api/gql';
import { notify } from '../../../utils/notification';

type Props = {
  invoiceId: string;
  transNs?: string;
  keyPrefix?: string;
  onSuccess?: MutationOptions<
    UpdateInvoiceAmountDueMutation,
    any,
    UpdateInvoiceAmountDueMutationVariables
  >['onSuccess'];
};

export const SetPaidModule = ({ transNs, keyPrefix, onSuccess, invoiceId }: Props) => {
  const { t } = useTranslation(transNs, { keyPrefix });

  const { mutate, isPending: isMutating } = useUpdateInvoiceAmountDueMutation({
    onSuccess: (res, variables, context) => {
      notify.positive({ message: t('notification.success') });
      onSuccess?.(res, variables, context);
    },
    onError: (e) => {
      console.error(e);
      notify.negative({ message: t('notification.error') });
    },
  });

  const onSubmit = () => {
    mutate({
      invoiceId: invoiceId,
      amountDue: 0,
    });
  };

  return (
    <>
      <DialogTitle>{t('title')}</DialogTitle>
      <DialogContent dividers sx={{ position: 'relative' }}>
        <Typography whiteSpace={'break-spaces'}>{t('contentText')}</Typography>

        <Box mt={4} display={'flex'} flexDirection={'column'} gap={2}>
          <LoadingButton
            loading={isMutating}
            variant={'contained'}
            size={'large'}
            onClick={onSubmit}
            startIcon={<Check />}
          >
            {t('action.submit')}
          </LoadingButton>
          <Button component={Link} to={'..'}>
            {t('action.cancel')}
          </Button>
        </Box>
      </DialogContent>
    </>
  );
};
